export class EksVolumeRestoreResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoredVolumeId",
            "baseName": "restoredVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceVolumeId",
            "baseName": "sourceVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourcePvcName",
            "baseName": "sourcePvcName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourcePvName",
            "baseName": "sourcePvName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EksVolumeRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
